import React, { Component, PropTypes } from 'react';
import { withRouter } from 'react-router';
import {
  StudentActions,
  GroupActions,
  UserActions,
  InviteActions,
  InvitationActions
} from 'actions';
import SimpleOverview from 'components/Widgets/SimpleOverview';
import {
  List,
  Styles,
  ListItem,
  FlatButton,
  FontIcon,
  Dialog,
  DatePicker,
  Toolbar,
  ToolbarTitle,
  ToolbarGroup,
  TextField,
  Toggle,
  RaisedButton
} from 'material-ui';
import Message from 'services/Message';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import ScrollableContainer from 'components/ScrollableContainer';
import ToolbarIconButton from 'components/Material/ToolbarIconButton';
import * as Icons from 'components/Material/SvgIcons';
import CourseSelector from 'components/CourseSelector';
import StudentSelector from 'components/StudentSelector';
import InviteeAdder from 'components/InviteeAdder';
import DialogPortal from 'components/DialogPortal';
let { Spacing, Colors } = Styles;

const styles = {
  label: {
    padding: '10px'
  }
};

const minDate = new Date();
const maxDate = new Date();
maxDate.setFullYear(maxDate.getFullYear() + 2);

class GroupDetail extends mixin(
  RefluxMixin,
  Authorizer,
  Component
) {
  //  mixins: [AuthMixin, IntlMixin, Reflux.connect(StudentStore, 'student'), Reflux.connect(GroupStore, 'group'), Reflux.connect(CourseStore, 'course'), Reflux.connect(InviteStore, 'invite')],
  static contextTypes = {
    getIntlMessage: PropTypes.func,
    muiTheme: PropTypes.object
  };

  state = {
    // selectedStudent: {name: this.context.getIntlMessage('student.noSelected')},
    // selectedInvitation: {name: this.context.getIntlMessage('student.noSelected')},
    studentsLoaded: false,
    coursesLoaded: false,
    invitesLoaded: false,
    editing: false,
    exporting: false,
    value: ''
  };

  confirmDelete() {
    this.refs.confirmDialog.show();
  }

  selectStudent(student) {
    this.setState({ selectedStudent: student });
  }

  selectInvitation(invitation) {
    this.setState({ selectedInvitation: invitation });
  }

  onConfirm() {
    this.refs.removeDialog.dismiss();
    GroupActions.delete(this.props.group.id, true, () => {
      this.closeDetail();
      GroupActions.filter();
    });
  }

  conConfirmRemove() {
    this.refs.removeDialog.dismiss();
    StudentActions.removeFromGroup(
      this.groupId,
      this.state.selectedStudent.id,
      () => {
        Message.info(this.context.getIntlMessage('student.removedFromGroup'));
        StudentActions.findByGroupId(this.groupId);
      }
    );
  }

  revokeAccess() {
    this.refs.removeDialog.show();
  }

  closeDetail() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  inviteStudents() {
    this.refs.inviteStudentsDialog.show();
  }

  createInviteStudentsDialog() {
    let { group } = this.props,
      actions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Invite'),
          onTouchTap: this._inviteStudentsConfirm.bind(this),
          ref: 'submit'
        }
      ];

    return (
      <Dialog
        ref="inviteStudentsDialog"
        actions={actions}
        actionFocus="submit"
        dismissOnClickAway={true}
        autoDetectWindowHeight={true}
        autoScrollBodyContent={true}
      >
        <InviteeAdder ref="invitees" standAlone={true} />
      </Dialog>
    );
  }

  addCourses() {
    this.refs.addCoursesDialog.show();
  }

  createAddCoursesDialog() {
    let { group } = this.props,
      actions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Add'),
          onTouchTap: this._addCoursesConfirm.bind(this),
          ref: 'submit'
        }
      ];

    return (
      <Dialog
        ref="addCoursesDialog"
        actions={actions}
        actionFocus="submit"
        dismissOnClickAway={true}
        autoDetectWindowHeight={true}
        autoScrollBodyContent={true}
      >
        {this.context.getIntlMessage('invite.accessTime')} :{' '}
        <DatePicker
          style={{ display: 'inline-block' }}
          ref="endDate"
          minDate={minDate}
          maxDate={maxDate}
          hintText={this.context.getIntlMessage('invite.chooseEndDate')}
        />
        <CourseSelector ref="courseSelector" />
      </Dialog>
    );
  }

  _addCoursesConfirm() {
    const courseIds = Object.keys(this.refs.courseSelector.getSelected()).map(
      id => parseInt(id, 10)
    );
    const endDate = this.refs.endDate.getDate();
    GroupActions.addToCourse(this.props.group.id, courseIds, endDate);
    this.refs.addCoursesDialog.dismiss();
  }

  addStudents() {
    this.refs.addStudentsDialog.show();
  }

  createAddStudentsDialog() {
    let { group } = this.props,
      actions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Add'),
          onTouchTap: this._addStudentsConfirm.bind(this),
          ref: 'submit'
        }
      ];

    return (
      <Dialog
        ref="addStudentsDialog"
        actions={actions}
        actionFocus="submit"
        dismissOnClickAway={true}
        autoDetectWindowHeight={true}
        autoScrollBodyContent={true}
      >
        <StudentSelector ref="studentSelector" />
      </Dialog>
    );
  }

  _inviteStudentsConfirm() {
    InviteActions.inviteToCircle(
      this.refs.invitees.getInvitees(),
      this.props.group.id,
      () => {
        Message.info(this.context.getIntlMessage('student.multiAddedToGroup'));
        this.refs.inviteStudentsDialog.dismiss();
        GroupActions.findById(this.props.group.id);
      }
    );
  }

  _addStudentsConfirm() {
    let userIds = Object.keys(this.refs.studentSelector.getSelected()).map(id =>
      parseInt(id, 10)
    );
    UserActions.addToCircle(userIds, [this.props.group.id], () => {
      Message.info(this.context.getIntlMessage('student.multiAddedToGroup'));
      this.refs.addStudentsDialog.dismiss();
      GroupActions.findById(this.props.group.id);
    });
  }

  removeCourse(course) {
    this._courseToRemove = course;
    this.refs.removeCourseDialog.show();
  }

  _onRemoveCourseConfirm() {
    GroupActions.removeFromCourse(this.props.group.id, this._courseToRemove.id);
    Message.info(this.context.getIntlMessage('course.removed'));
    this.refs.removeCourseDialog.dismiss();
  }

  removeStudent(student) {
    this._studentToRemove = student;
    this.refs.removeStudentDialog.show();
  }

  _onRemoveStudentConfirm() {
    StudentActions.removeFromGroup(
      this.props.group.id,
      this._studentToRemove.id
    );
    GroupActions.findById(this.props.group.id);
    Message.info(this.context.getIntlMessage('student.removedFromGroup'));
    this.refs.removeStudentDialog.dismiss();
  }

  _onRemoveInviteConfirm() {
    InvitationActions.delete(this._inviteToRemove.id);
    GroupActions.findById(this.props.group.id);
    Message.info(this.context.getIntlMessage('group.removedInvite'));
    this.refs.removeInviteDialog.dismiss();
  }

  removeInvite(invite) {
    this._inviteToRemove = invite;
    this.refs.removeInviteDialog.show();
  }

  resendInvitation(invitation) {
    this.setState({ selectedInvitation: invitation });
    this.refs.resendInvitationDialog.show();
  }

  resendInvitationAll(invitations) {
    this.setState({ selectedInvitation: invitations });
    this.refs.resendInvitationAllDialog.show();
  }

  _onResendInvitationConfirm() {
    InvitationActions.resend(this.state.selectedInvitation.id);
    Message.info(this.context.getIntlMessage('invitation.resent'));
    this.refs.resendInvitationDialog.dismiss();
  }

  _onResendInvitationAllConfirm() {
    InvitationActions.resend(
      this.props.group.invitations.map(invitation => {
        return invitation.id;
      })
    );
    Message.info(this.context.getIntlMessage('invitation.allResent'));
    this.refs.resendInvitationAllDialog.dismiss();
  }

  updateGroupName() {
    const grName = this.refs.groupName.getValue();
    GroupActions.update(this.props.group.id, grName);
    this.closeEdit();
  }

  updateStudent(student) {
    if (student.role == 'user') {
      UserActions.setCircleRole(student.id, this.props.group.id, 'admin');
      GroupActions.findById(this.props.group.id);
    } else {
      UserActions.setCircleRole(student.id, this.props.group.id, 'user');
      GroupActions.findById(this.props.group.id);
    }
  }

  exportFinal = () => {
    let { group } = this.props;
    
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let email = null;
    if(re.test(String(this.state.value).toLowerCase())){
      email = this.state.value;
    }

    let options = {
      startDate: this.refs.startDate.getDate(),
      endDate: this.refs.endDate.getDate(),
      circleIds: [group.id],
      withInactive: this.refs.withInactive.isToggled(),
      withProgress: this.refs.withProgress.isToggled(),
      recipientEmail: email
    };

    StudentActions.export(options);
  }

  openEdit = () => {
    this.setState({ editing: true });
  };

  closeEdit = () => {
    this.setState({ editing: false });
  };

  export = () => {
    this.setState({ exporting: true });
  };

  closeExport = () => {
    this.setState({ exporting: false });
  };

  goToStudent = (item) => {
    if (item === null) {
      this.setState({ student: null });
    } else {
      this.props.router.push(`/student/${item.id}`);
    }
  };

  goToCourse = (item) => {
    if (item === null) {
      this.setState({ student: null });
    } else {
      this.props.router.push(`/course/${item.id}`);
    }
  };

  handleChange = (e) => {
    this.setState({ value: e.target.value})
  }

  render() {
    let { group, user } = this.props,
      addCoursesDialog = this.createAddCoursesDialog(),
      addStudentsDialog = this.createAddStudentsDialog(),
      removeInvitesDialog,
      inviteStudentsDialog,
      inviteStudentsDialog2,
      standardActions = [
        <FlatButton
          key="ok"
          label={this.context.getIntlMessage('OK')}
          secondary={true}
          className="full"
          onTouchTap={this.onConfirm.bind(this)}
        />
      ],
      removeCourseActions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Remove'),
          onTouchTap: this._onRemoveCourseConfirm.bind(this),
          ref: 'submit'
        }
      ],
      removeStudentActions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Remove'),
          onTouchTap: this._onRemoveStudentConfirm.bind(this),
          ref: 'submit'
        }
      ],
      removeInviteActions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Remove'),
          onTouchTap: this._onRemoveInviteConfirm.bind(this),
          ref: 'submit'
        }
      ],
      resendInvitationActions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Resend'),
          onTouchTap: this._onResendInvitationConfirm.bind(this),
          ref: 'submit'
        }
      ],
      resendInvitationAllActions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Resend'),
          onTouchTap: this._onResendInvitationAllConfirm.bind(this),
          ref: 'submit'
        }
      ],
      inviteOverview;

    let resendButton = null;

    if (
      this.props.group &&
      this.props.group.invitations &&
      this.props.group.invitations.length !== 0
    ) {
      resendButton = (
        <div>
          <List>
            <ListItem
              leftIcon={<Icons.NavigationRefresh />}
              onTouchTap={this.resendInvitationAll.bind(this)}
              primaryText={this.context.getIntlMessage('invitation.resendAll')}
            />
          </List>
        </div>
      );
    }

    inviteStudentsDialog = this.createInviteStudentsDialog()
    inviteOverview = (
      <SimpleOverview
        items={group.invitations}
        readable="email"
        title={this.context.getIntlMessage('invite.Invites')}
        onTouchTapRightIcon={this.removeInvite.bind(this)}
        onTouchTapLeftIcon={this.resendInvitation.bind(this)}
      >
        {resendButton}
      </SimpleOverview>
    );
    removeInvitesDialog = (
      <Dialog
        ref="removeInviteDialog"
        title={this.context.getIntlMessage('group.removeInvite')}
        actions={removeInviteActions}
        actionFocus="submit"
        dismissOnClickAway={true}
      >
        {this.context.getIntlMessage('group.removeInviteConfirm')}
      </Dialog>
    );
    inviteStudentsDialog2 = (
      <div>
        <Dialog
          ref="resendInvitationDialog"
          title={this.context.getIntlMessage('invitation.resend')}
          actions={resendInvitationActions}
          actionFocus="submit"
          dismissOnClickAway={true}
        >
          {this.context.getIntlMessage('invitation.prolongAccess')}
        </Dialog>
        <Dialog
          ref="resendInvitationAllDialog"
          title={this.context.getIntlMessage('invitation.resendAll')}
          actions={resendInvitationAllActions}
          actionFocus="submit"
          dismissOnClickAway={true}
        >
          {this.context.getIntlMessage('invitation.resendAll')}
        </Dialog>
      </div>
    );
    if (!this.state.editing && !this.state.exporting) {
      let toolbar = (
        <Toolbar>
          <ToolbarGroup float={'left'} key={0}>
            <ToolbarTitle text={this.context.getIntlMessage('Group')} />
          </ToolbarGroup>
          <ToolbarGroup float={'right'} key={1}>
            {user && user.role.editor ? (
              <ToolbarIconButton
                tooltip={this.context.getIntlMessage('group.remove')}
                tooltipPosition="bottom-center"
                svgIcon={<Icons.ActionDelete />}
                onTouchTap={this.revokeAccess.bind(this)}
              />
            ) : null}
            {user && user.role.editor ? (
              <ToolbarIconButton
                tooltip={this.context.getIntlMessage('course.add')}
                tooltipPosition="bottom-center"
                svgIcon={<Icons.ActionAssignmentInd />}
                onTouchTap={this.addCourses.bind(this)}
              />
            ) : null}
            {user && user.role.editor ? (
              <ToolbarIconButton
                tooltip={this.context.getIntlMessage('student.add')}
                tooltipPosition="bottom-center"
                svgIcon={<Icons.SocialPersonAdd />}
                onTouchTap={this.addStudents.bind(this)}
              />
            ) : null}
            <ToolbarIconButton
              tooltip={this.context.getIntlMessage('student.inviteNew')}
              tooltipPosition="bottom-center"
              svgIcon={<Icons.ContentMail />}
              onTouchTap={this.inviteStudents.bind(this)}
            />
            <ToolbarIconButton
              tooltip={this.context.getIntlMessage('export.userStats')}
              tooltipPosition="bottom-center"
              svgIcon={<Icons.ActionLaunch  />}
              onTouchTap={this.export.bind(this)}
            />
            <ToolbarIconButton
              tooltip={this.context.getIntlMessage('Close')}
              tooltipPosition="bottom-center"
              svgIcon={<Icons.ContentClear />}
              onTouchTap={this.closeDetail.bind(this)}
            />
          </ToolbarGroup>
        </Toolbar>
      );

      return (
        <ScrollableContainer header={toolbar}>
          <List>
            <ListItem
              leftIcon={<Icons.ContentCreate />}
              primaryText={group.name}
              onTouchTap={this.openEdit.bind(this)}
            />
          </List>
          <SimpleOverview
            items={group.courses}
            readable="name"
            title={this.context.getIntlMessage('course.Courses')}
            onTouchTapRightIcon={this.removeCourse.bind(this)}
            user={user}
            onSelect={this.goToCourse}
          />
          <SimpleOverview
            removable
            items={group.students}
            readable="name"
            title={this.context.getIntlMessage('student.Students')}
            onTouchTapRightIcon={this.removeStudent.bind(this)}
            onTouchTapRightToggle={this.updateStudent.bind(this)}
            user={user}
            onSelect={this.goToStudent}
          />
          {inviteOverview}
          <DialogPortal>
            <Dialog
              ref="removeDialog"
              title={this.context.getIntlMessage('group.remove')}
              actions={standardActions}
              dismissOnClickAway={true}
            />
            <Dialog
              ref="removeCourseDialog"
              title={this.context.getIntlMessage('group.removeCourse')}
              actions={removeCourseActions}
              actionFocus="submit"
              dismissOnClickAway={true}
            >
              {this.context.getIntlMessage('group.removeCourseConfirm')}
            </Dialog>
            <Dialog
              ref="removeStudentDialog"
              title={this.context.getIntlMessage('group.removeStudent')}
              actions={removeStudentActions}
              actionFocus="submit"
              dismissOnClickAway={true}
            >
              {this.context.getIntlMessage('group.removeStudentConfirm')}
            </Dialog>
            {removeInvitesDialog}
            {addCoursesDialog}
            {addStudentsDialog}
            {inviteStudentsDialog}
            {inviteStudentsDialog2}
          </DialogPortal>
        </ScrollableContainer>
      );
    } else if (this.state.exporting) {
      let toolbar = (
        <Toolbar>
          <ToolbarGroup float={'left'} key={0}>
            <ToolbarTitle
              text={this.context.getIntlMessage('Export user statistics')}
            />
          </ToolbarGroup>
          <ToolbarGroup float={'right'} key={1}>
            <ToolbarIconButton
              tooltip={this.context.getIntlMessage('Cancel')}
              tooltipPosition="bottom-center"
              svgIcon={<Icons.ContentClear />}
              onTouchTap={this.closeExport.bind(this)}
            />
          </ToolbarGroup>
        </Toolbar>
      );

      let recipient = null;
      if (this.props.user.incarnated) {
        recipient = (
          <div>
            <Toggle
              ref="withRecipient"
              defaultToggled={false}
              label={this.context.getIntlMessage('group.send')}
            />
          </div>
        );
      }
      const now = new Date();
      const oneMonthAgo = new Date();
      const month = oneMonthAgo.getMonth();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

      if (oneMonthAgo.getMonth() === month) {
        oneMonthAgo.setDate(0);
      }

      oneMonthAgo.setHours(0, 0, 0);
      return (
        <ScrollableContainer
          header={toolbar}
          style={{ backgroundColor: Colors.fullWhite }}
        >
          <div style={{ padding: Spacing.desktopGutterMini }}>
            <DatePicker
              ref="startDate"
              defaultDate={oneMonthAgo}
              maxDate={now}
              floatingLabelText={this.context.getIntlMessage(
                'export.startDate'
              )}
            />
            <DatePicker
              ref="endDate"
              defaultDate={now}
              maxDate={now}
              floatingLabelText={this.context.getIntlMessage('export.endDate')}
            />
            <TextField onChange={this.handleChange} hintText="Custom email" />
            <Toggle
              ref="withInactive"
              defaultToggled={false}
              label={this.context.getIntlMessage('export.user.withInactive')}
            />
            <Toggle
              ref="withProgress"
              defaultToggled={false}
              label={this.context.getIntlMessage('export.user.withProgress')}
            />
            {recipient}
            <RaisedButton
              primary
              fullWidth
              label={this.context.getIntlMessage('Export')}
              onTouchTap={this.exportFinal}
            />
          </div>
        </ScrollableContainer>
      );
    } else {
      let toolbar = (
        <Toolbar>
          <ToolbarGroup float={'left'} key={0}>
            <ToolbarTitle text={this.context.getIntlMessage('group.editing')} />
          </ToolbarGroup>
          <ToolbarGroup float={'right'} key={1}>
            <ToolbarIconButton
              tooltip={this.context.getIntlMessage('Save')}
              tooltipPosition="bottom-center"
              svgIcon={<Icons.ActionDone />}
              onTouchTap={this.updateGroupName.bind(this)}
            />
            <ToolbarIconButton
              tooltip={this.context.getIntlMessage('Cancel')}
              tooltipPosition="bottom-center"
              svgIcon={<Icons.ContentClear />}
              onTouchTap={this.closeEdit.bind(this)}
            />
          </ToolbarGroup>
        </Toolbar>
      );
      return (
        <ScrollableContainer header={toolbar}>
          <div style={styles.label}>
            <TextField
              fullWidth
              defaultValue={group.name}
              hintText=""
              floatingLabelText="Group Name"
              ref="groupName"
              type="text"
            />
          </div>
          <SimpleOverview
            items={group.courses}
            readable="name"
            title={this.context.getIntlMessage('course.Courses')}
            onTouchTapRightIcon={this.removeCourse.bind(this)}
          />
          <SimpleOverview
            items={group.students}
            readable="name"
            title={this.context.getIntlMessage('student.Students')}
            onTouchTapRightIcon={this.removeStudent.bind(this)}
          />
          {inviteOverview}
          <DialogPortal>
            <Dialog
              ref="removeDialog"
              title={this.context.getIntlMessage('group.remove')}
              actions={standardActions}
              dismissOnClickAway={true}
            />
            <Dialog
              ref="removeCourseDialog"
              title={this.context.getIntlMessage('group.removeCourse')}
              actions={removeCourseActions}
              actionFocus="submit"
              dismissOnClickAway={true}
            >
              {this.context.getIntlMessage('group.removeCourseConfirm')}
            </Dialog>
            <Dialog
              ref="removeStudentDialog"
              title={this.context.getIntlMessage('group.removeStudent')}
              actions={removeStudentActions}
              actionFocus="submit"
              dismissOnClickAway={true}
            >
              {this.context.getIntlMessage('group.removeStudentConfirm')}
            </Dialog>
            {removeInvitesDialog}
            {addCoursesDialog}
            {addStudentsDialog}
            {inviteStudentsDialog}
            {inviteStudentsDialog2}
          </DialogPortal>
        </ScrollableContainer>
      );
    }
  }
}

export default withRouter(GroupDetail)


// WEBPACK FOOTER //
// ./src/js/components/Route/Group/Detail.js